import { userInfoState } from '@/state/userInfo/state';
import { useAtomValue } from 'jotai';

export const useUser = () => {
  const { userMetaData } = useAtomValue(userInfoState);
  const isCurrentUser = (userId) => {
    if (!userMetaData) return false;
    return String(userMetaData?.uid) === String(userId);
  };
  return {
    isCurrentUser,
    name: userMetaData?.name,
  };
};
